import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export const SendBeoEmailForm = (strings: any, isAddSubject: boolean): FormModel[] => {
  const form: FormModel[] = [
    {
      label: strings.beo_to_email_text,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      multiline: true,
      minRows: 1,
      maxRows: 3,
      variant: 'outlined',
      placeholder: '',
      field: 'to',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateEmailList }],
      responsive: { xs: 12, md: 12 },
      required: true,
    },
    {
      label: strings.beo_cc_email_text,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'cc',
      validators: [{ check: Validators.validateEmailList }],
      responsive: { xs: 12, md: 12 },
      required: false,
      multiline: true,
      minRows: 1,
      maxRows: 3,
    },
    {
      label: strings.beo_bcc_email_text,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'bcc',
      validators: [{ check: Validators.validateEmailList }],
      responsive: { xs: 12, md: 12 },
      required: false,
      multiline: true,
      minRows: 1,
      maxRows: 3,
    },
  ];
  isAddSubject &&
    form.push(
      {
        label: 'Subject',
        value: '',
        size: 'medium',
        autoFocus: false,
        type: 'text',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'subject',
        validators: [{ check: Validators.validateString }],
        responsive: { xs: 12, md: 12 },
        required: true,
        multiline: true,
        minRows: 1,
        maxRows: 2,
      },
      {
        label: 'Compose email',
        value: '',
        autoFocus: true,
        type: 'textEditor',
        placeholder: '',
        field: 'text',
        validators: [],
        defaultSource: false,
        responsive: { xs: 12, md: 12 },
        required: false,
      },
    );
  return form;
};
